/* eslint-disable no-param-reassign */
import { Validator } from 'vee-validate';

async function validateRow(validator, row, rules, keys, labels) {
    const status = { $valid: true, idx: row.idx };
    await Promise.all(keys.map(async (key) => {
        const { valid, errors } = await validator.verify(row[key], rules[key], {
            name: labels[key],
            values: row,
        });
        status[key] = { valid, errors };
        if (!valid) {
            status.$valid = false;
        }
    }));
    return status;
}

export default class BulkValidator {
    /**
     * @param {Object[]} data
     * @param rules
     * @param labels
     */
    constructor(rules, labels, customValidator) {
        this.labels = labels;
        this.rules = rules;
        this.validator = new Validator();
        if (customValidator) {
            this.customValidation = customValidator;
        }
    }

    /**
     *
     * @param data
     * @param {string[]} fields
     * @returns {Promise<Object[]>}
     */
    validate(data, fields = null) {
        const { labels, rules, validator } = this;
        const keys = fields || Object.keys(rules);

        return Promise.all(data.map(async (row) => {
            const status = await validateRow(validator, row, rules, keys, labels);
            this.customValidation(row, status, data, validator);
            this.nonExistenceValidation(row, status);
            return status;
        }));
    }

    async validateRow(row, fields = null, customValidation = null, data = null) {
        const { labels, rules, validator } = this;
        const keys = fields || Object.keys(rules);
        const status = await validateRow(validator, row, rules, keys, labels);
        if (customValidation) {
            customValidation(row, status, data, validator);
        }
        return status;
    }

    // eslint-disable-next-line no-unused-vars,class-methods-use-this
    customValidation(row, status, data) {
        return true;
    }

    // eslint-disable-next-line class-methods-use-this
    nonExistenceValidation(row, status) {
        if (row.errorMessage !== null && row.errorMessage.length > 0) {
            const field = status.sku || { valid: false, errors: [] };
            field.valid = false;

            if (!field.errors.includes(row.errorMessage)) {
                // field.errors = [...field.errors, row.errorMessage];
                field.errors.push(row.errorMessage);
            }

            status.sku = field;
            status.$valid = false;
        }
    }
}
